import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($translate, $scope, $state, $q, $stateParams, ModalService, PolicyService, ViewModelService) {
  $scope.jobNumber = $stateParams.jobNumber;$scope.policyNumber = $stateParams.policyNumber;
  $scope.withdraw = function () {
    var withdrawModal = ModalService.showConfirm('Confirmation', 'Do you wish to withdraw this policy change?', '', 'Withdraw', '', 'Cancel').result;
    withdrawModal.then(function (res) {
      //$scope.$emit("withdrawSubmitted");
      var withdrawPromise = PolicyService.withdrawPolicyTransaction($scope.policyNumber, $scope.jobNumber);
      withdrawPromise.then(function (res) {
        //$scope.$emit("withdrawSubmitted");

        $state.go('policies.detail.summary', {
          'policyNumber': $scope.policyNumber
        });
      });
    });
  };
};
fn.$inject = ['$translate', '$scope', '$state', '$q', '$stateParams', 'ModalService', 'PolicyService', 'ViewModelService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/policy/PreemptionCtrl.js
// module id = 1712
// module chunks = 0